export default __webpack_public_path__ + "static/media/insta_feed_hochkant.7300b1aa.jpg";